import {
  getDocstoreCiphers,
  GetDocstoreCiphersRequest,
} from './get-docstore-ciphers'
import { getDocstoreSection } from './get-docstore-section'
import {
  getDocstoreFilters,
  GetDocstoreFiltersRequest,
} from './getDocstoreFilters'

import type { GetDocstoreSectionRequest } from './get-docstore-section'

export const documentTypeMapper: Record<string, string> = {
  PERMIT: 'permits',
  WORKING_DRAFT: 'workingdraft',
  EXECUTIVE_DRAWING: 'executivedrawing',
  EXECUTIVE_SCHEME: 'executivescheme',
  BIN: 'bin',
  SUPPORTING: 'supporting',
  LABORATORY: 'laboratorydata',
  NORMATIVE: 'normative',
  CERTIFICATE: 'certificate',
}

export const docstoreQueries = {
  root: () => ['filestore'],
  docstore: (projectId?: string | null, documentType?: string) => [
    ...docstoreQueries.root(),
    'docstore',
    { projectId, documentType },
  ],

  getDocstoreSection: ({ section, params }: GetDocstoreSectionRequest) => ({
    queryFn: () =>
      getDocstoreSection({ section: documentTypeMapper[section], params }),
    queryKey: [...docstoreQueries.docstore(params.projectId, section), params],
  }),

  getDocstoreFilters: (
    params: GetDocstoreFiltersRequest & { enabled?: boolean },
  ) => ({
    queryFn: () =>
      getDocstoreFilters({
        ...params,
        section: documentTypeMapper[params.section],
      }),
    queryKey: [
      ...docstoreQueries.docstore(params.projectId, params.section),
      'filters',
      params,
    ],
    enabled: params.enabled,
  }),

  getDocstoreCiphers: (
    params: GetDocstoreCiphersRequest & { enabled?: boolean },
  ) => ({
    queryFn: () =>
      getDocstoreCiphers({
        ...params,
        section: documentTypeMapper[params.section],
      }),
    queryKey: [
      ...docstoreQueries.docstore(params.projectId, params.section),
      'ciphers',
      params,
    ],
    enabled: params.enabled,
  }),
}
